// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__cMj5l","buttons":"Footer_buttons__3n5G8"};